import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, HeadContent, Link, Outlet } from '@tanstack/react-router'
import { Logo } from '@/components/brand/logo'
import { Button } from '@/components/ui/button'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <TooltipProvider delayDuration={300}>
      <HeadContent />
      <Outlet />
      <Toaster />
    </TooltipProvider>
  ),
  notFoundComponent: NotFound,
})

function NotFound() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col items-start justify-center gap-5 px-6">
      <Logo />
      <div className="space-y-2">
        <h1 className="text-headline font-semibold">This page doesn't exist</h1>
        <p className="text-muted-foreground text-[15px]">The link may be old, or the page moved.</p>
      </div>
      <Button asChild>
        <Link to="/">Go to dashboard</Link>
      </Button>
    </main>
  )
}
